module.exports = __webpack_public_path__ + "static/media/15.bd9ab610.jpg";